import React from "react";
import ReactDOM from "react-dom";
import "./main.css";
import App from "./App";

const container = document.getElementById("root");

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  container
);
